<template>
  <vx-card class="h-full w-full overflowDefinition">
    <employee-reports :venueId="meetingInstance.venueId" />
  </vx-card>
</template>

<script>
import Question from "../MeetingQuestion.vue";
import EmployeeReports from "@/views/modules/campus/Employees/EmployeeReports.vue";
export default {
  props: ["step", "meetingInstance"],
  components: { Question, EmployeeReports },
  data() {
    return {
      // previewPopupActive: false,
    };
  },
  mounted() {
    console.log("Mounted with VID", this.venueId);
  },
  methods: {},
};
</script>

<style lang="scss">
.overflowDefinition {
  max-height: 70vh;
  overflow-y: auto;
}
</style>

